module.exports = __webpack_public_path__ + "img/s00170.97b5ff0a.png";